import Box from '../../Atoms/Box';
import CCText from '../../Atoms/CCText';
import CCButton from '../../Atoms/CCButton';
import React, {useEffect, useRef, useState} from 'react';
import SafeAreaWrapper from '../../Atoms/SafeViewWrapper';
import Spacer from '@/Atoms/Spacer';
import {vs, FontSizes} from '../../Utils/Dimensions';
import {styles} from './styles';
import CCTextInput from '@/Atoms/CCTextInput';
import {sendOtp, verifyOtp} from '@/Hooks/LoginApi/loginApi';
import {
  isCsocAssessmentLead,
  submitCsocCallback,
  createTicket,
} from '@/Utils/csocLead';
import ConditionalRender from '@/Atoms/ConditionalRender';
import OtpInput from 'react-otp-input';
import {
  isValidEmail,
  setLocalStorage,
  removeLocalStorage,
  getLocalStorage,
} from '@/Utils/CommonUtils';
import {queryClient} from '@/Utils/queryClient';
import {useNavigation, useRoute} from '@react-navigation/native';
import {
  Modal,
  Pressable,
  TouchableOpacity,
  View,
  Image,
  Text,
  useWindowDimensions,
} from 'react-native';
import CCColors from '@/Utils/CCColors';
import loginSidePattern from '../../Assets/Images/Svgs/login_side_pattern.svg';
// Note: the source design's own "-light"/"-dark" asset names describe the
// logo's ink color, not where it's used, and are the inverse of what actually
// reads on each background — cc_logo_dark (white ink) goes on the dark side
// panel, cc_logo_light (brown ink) goes on the white card.
import ccLogoOnDark from '../../Assets/Images/Svgs/cc_logo_dark.svg';
import ccLogoOnLight from '../../Assets/Images/Svgs/cc_logo_light.svg';
import countryCodes from './countryCodes.json';
import CCSelect from '@/Atoms/CCSelect';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import CCCheckbox from '@/Atoms/CCCheckbox';
import SlideModal from '@/Atoms/SlideModal';
import TncContext from './components/TncContext';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileContract} from '@fortawesome/free-solid-svg-icons';
import SwitchToAppBanner from '@/Atoms/Header/SwitchToAppBanner';
import SwitchToAppModal from '@/Atoms/Header/SwitchToAppModal';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {LOGIN_HERO, formatSentTo} from './loginHero';
import {
  toCountryPickerItems,
  resolveInitialCountryCode,
  interpretSendOtpResponse,
  extractApiErrorMessage,
} from './loginUtils';
import FeatureCarousel from './components/FeatureCarousel';

const LAST_DIAL_CODE_KEY = 'last_dial_code';

const SIDE_PANEL_USPS = [
  {glyph: '♞', label: 'Game play & review'},
  {glyph: '♛', label: 'Assessments'},
  {glyph: '♜', label: 'Parental controls'},
];

// Faint scattered chess pieces filling the empty margins around the main
// content block (mostly above/below it, since that block is vertically
// centered and leaves a lot of open space on tall viewports).
const BROWN_PANEL_DECOR = [
  {glyph: '♞', top: '6%', left: '70%', size: 130, opacity: 0.07, rotate: '-14deg'},
  {glyph: '♛', top: '80%', left: '66%', size: 150, opacity: 0.06, rotate: '10deg'},
  {glyph: '♜', top: '4%', left: '18%', size: 80, opacity: 0.06, rotate: '8deg'},
  {glyph: '♝', top: '86%', left: '6%', size: 90, opacity: 0.06, rotate: '-8deg'},
  {glyph: '♚', top: '36%', left: '86%', size: 100, opacity: 0.07, rotate: '12deg'},
  {glyph: '♟', top: '58%', left: '4%', size: 70, opacity: 0.06, rotate: '-4deg'},
];
const CREAM_PANEL_DECOR = [
  {glyph: '♟', top: '8%', left: '58%', size: 100, opacity: 0.06, rotate: '-10deg'},
  {glyph: '♙', top: '82%', left: '55%', size: 90, opacity: 0.06, rotate: '12deg'},
  {glyph: '♗', top: '10%', left: '12%', size: 70, opacity: 0.05, rotate: '-6deg'},
  {glyph: '♖', top: '80%', left: '14%', size: 80, opacity: 0.05, rotate: '9deg'},
];
// Smaller/sparser variant for the narrow mobile column — tucked into the
// corners so it never sits behind the carousel card or the form fields.
const MOBILE_PANEL_DECOR = [
  {glyph: '♟', top: '2%', left: '76%', size: 46, opacity: 0.05, rotate: '-8deg'},
  {glyph: '♗', top: '92%', left: '6%', size: 48, opacity: 0.05, rotate: '10deg'},
  {glyph: '♖', top: '93%', left: '76%', size: 42, opacity: 0.05, rotate: '-6deg'},
];
// Tuned for the short brown hero band (carousel height only) rather than
// the full column, so pieces sit in its corners without crowding the card.
const MOBILE_HERO_DECOR = [
  {glyph: '♞', top: '5%', left: '78%', size: 44, opacity: 0.08, rotate: '-10deg'},
  {glyph: '♟', top: '86%', left: '6%', size: 40, opacity: 0.07, rotate: '8deg'},
];

function DecorativePieces({items, color}: {items: typeof BROWN_PANEL_DECOR; color: string}) {
  return (
    <>
      {items.map((item, i) => (
        <Text
          key={i}
          allowFontScaling={false}
          pointerEvents="none"
          style={{
            position: 'absolute',
            top: item.top,
            left: item.left,
            fontSize: item.size,
            color,
            opacity: item.opacity,
            transform: [{rotate: item.rotate}],
          }}>
          {item.glyph}
        </Text>
      ))}
    </>
  );
}

let timer;
function Login({onLoginStateChange, isEvaluate = false, setUrlTournamentId}) {
  const navigation = useNavigation<any>();
  const route = useRoute();
  const tournamentId = route.params?.tournamentId;
  const [isLogin, setIsLogin] = useState<boolean>(true);
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [loginError, setLoginError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [counter, setCounter] = useState<string>('');
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [onboardingMessage, setOnboardingMessage] = useState<string>('');
  const [showAppModalHome, setShowAppModalHome] = useState(false);
  const [enableRegistration, setEnableRegistration] = useState<boolean>(false);
  const [countryCode, setCountryCode] = useState('+91');
  const [checkboxValue, setCheckboxValue] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const {isMobileOrTab} = useMediaQuery();
  const {width: windowWidth} = useWindowDimensions();
  // Side panel is a 40% column (min 340px, see sidePanelDesktop) — derive the
  // carousel's width from what actually renders instead of a fixed px value,
  // so cards don't overflow/get clipped on narrower desktop viewports.
  const sidePanelContentWidth = Math.max(
    260,
    Math.min(560, Math.max(windowWidth * 0.4, 340) - 40),
  );
  // Mobile column is full viewport width minus its own padding (vs(20) each
  // side) — deriving the carousel width from that instead of a fixed 260
  // stops it from being narrower than it needs to be on larger phones/tablets.
  const mobileContentWidth = Math.min(420, windowWidth - vs(40));
  const timerRef = useRef(null);
  const [tnc, setTnc] = useState<number>(0);
  const [viewpassword, setViewPassword] = useState<boolean>(false);
  const [loginData, setLoginData] = useState<{
    username: string;
    password: string;
    confirmpassword: string;
    email: string;
    isLogin: boolean;
    mobile: string;
    otp: string;
    ccadminpassword?: string;
    admin_login?: boolean;
  }>({
    username: '',
    password: '',
    confirmpassword: '',
    email: '',
    isLogin: true,
    mobile: '',
    otp: '',
    ccadminpassword: '',
    admin_login: route.name === 'Cc-admin-login',
  });

  // Restore the last-used dial code so returning intl users don't re-select it.
  useEffect(() => {
    (async () => {
      const stored = await getLocalStorage(LAST_DIAL_CODE_KEY);
      setCountryCode(resolveInitialCountryCode(stored as string | null));
    })();
  }, []);

  const sortedCountryCodes = countryCodes.sort((a, b) => {
    const firstTwoDigitsA = parseInt(
      b.dial_code.replace('+', '').slice(0, 2),
      10,
    );
    const firstTwoDigitsB = parseInt(
      a.dial_code.replace('+', '').slice(0, 2),
      10,
    );
    return firstTwoDigitsB - firstTwoDigitsA;
  });

  // Dial-code-first labels ("+91 · India") so the compact chip never clips to
  // something unreadable like "ia (+91)"; full label stays searchable by name.
  let codesArray = toCountryPickerItems(sortedCountryCodes);

  const SelectComponents = {
    IndicatorSeparator: null,
  };

  const filterCountries = (inputValue: string) => {
    if (!inputValue) {
      return codesArray;
    }

    const search = inputValue.toLowerCase();

    return codesArray.filter(option =>
      option.label.toLowerCase().includes(search),
    );
  };

  const loadCountryOptions = (
    inputValue: string,
    callback: (options: typeof codesArray) => void,
  ) => {
    setTimeout(() => {
      callback(filterCountries(inputValue));
    }, 200);
  };

  const handleOnSuccess = async (apiData: any) => {
    // setLocalStorage silently no-ops on a falsy value, so a 200 response that
    // came back without tokens used to write nothing, report success, and hand
    // over to the app — which then found no access_token and dropped the user
    // straight back on this screen with no explanation. Fail loudly instead.
    if (!apiData?.access_token) {
      setLoggedIn(false);
      setLoginError(true);
      setErrorMsg(
        apiData?.error ||
          'Could not complete sign in. Please request a new code and try again.',
      );
      return;
    }
    await setLocalStorage('refresh_token', apiData?.refresh_token, true);
    await setLocalStorage('access_token', apiData?.access_token, true);
    await setLocalStorage('userkey', apiData?.user_key, true);
    // prevent cross-account leakage of user-agnostic query keys (e.g. engagementSummary streak)
    queryClient.clear();
    // CSoC assessment lead: OTP verified -> mark the lead verified. Fires only
    // for clicks that came from a Caissa School of Chess page (csoc_lead=1).
    if (isCsocAssessmentLead()) {
      const fullPhone = (countryCode + (loginData.mobile || '')).replace(/\+/g, '');
      createTicket({email: loginData.email, phone: fullPhone});
    }
    setLoggedIn(true);
    onLoginStateChange(true);
  };
  const handleOnError = (apiData: any) => {
    setLoggedIn(false);
    setLoginError(true);
    // `apiData.error` alone rendered an empty banner whenever the failure
    // carried no `error` field (a WAF block's HTML body, a network drop).
    setErrorMsg(
      extractApiErrorMessage(apiData, 'An error occurred during the login process.'),
    );
  };

  const getFormattedTimeInMinutesAndSeconds = (min, sec) => {
    return `${min.toString().padStart(2, '0')}:${sec
      .toString()
      .padStart(2, '0')}`;
  };
  const startTimer = () => {
    let sec = 0;
    let min = 1;
    setCounter(getFormattedTimeInMinutesAndSeconds(min, sec));

    timerRef.current = setInterval(() => {
      if (sec === 0 && min === 0) {
        clearInterval(timerRef.current);
        setCounter('');
      } else {
        if (sec === 0) {
          min -= 1;
          sec = 60;
        }
        sec -= 1;
        setCounter(getFormattedTimeInMinutesAndSeconds(min, sec));
      }
    }, 1000);
  };
  const sendOtpSuccess = data => {
    setIsOtpSent(true);
    if (data && route.name !== 'Cc-admin-login') {
      setTnc(data?.tnc);
    }

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    startTimer();
  };

  const {mutate: sendOtpApi, isLoading: isSendOtpLoading} = sendOtp(
    sendOtpSuccess,
    handleOnError,
  );

  const {mutate: verifyOtpApi, isLoading: isVerifyOtpLoading} = verifyOtp(
    handleOnSuccess,
    handleOnError,
  );

  const handleLoginDataChange = (text: string, field: string) => {
    setLoginData(prev => ({...prev, [field]: text}));
  };

  useEffect(() => {
    setLoginError(false);
    if (!isLogin) {
      validateRegistration();
    }
  }, [loginData]);

  useEffect(() => {
    const handleEvaluate = async () => {
      let effectiveTournamentId = tournamentId;
      if (!effectiveTournamentId) {
        try {
          effectiveTournamentId =
            new URLSearchParams(window?.location?.search).get('tournamentId') ||
            undefined;
        } catch (e) {}
      }
      if (isEvaluate) {
        await setLocalStorage('isEvaluate', isEvaluate);
      } else {
        await removeLocalStorage('isEvaluate');
      }
      setUrlTournamentId(effectiveTournamentId);
      if (effectiveTournamentId) {
        await setLocalStorage('tournamentId', effectiveTournamentId);
      }
    };
    handleEvaluate();
  }, [isEvaluate, tournamentId]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const validateRegistration = () => {
    if (
      loginData.username === '' ||
      loginData.username?.trim() === '' ||
      loginData.username?.length < 4
    ) {
      setLoginError(true);
      setErrorMsg('Choose a username more than 4 characters');
      setEnableRegistration(false);
      return;
    }
    if (
      loginData.email === '' ||
      loginData.email?.trim() === '' ||
      !isValidEmail(loginData.email)
    ) {
      setLoginError(true);
      setErrorMsg('Share a valid email address');
      setEnableRegistration(false);
      return;
    }
    if (
      loginData.password === '' ||
      loginData.confirmpassword === '' ||
      loginData.password !== loginData.confirmpassword
    ) {
      setLoginError(true);
      setErrorMsg('Check your password fields please, make sure both match!');
      setEnableRegistration(false);
      return;
    }

    setEnableRegistration(true);
  };

  const sendOtpRequest = () => {
    try {
      const {mobile, ccadminpassword} = loginData;
      // Validate mobile number length (at least 5 digits)
      if (!mobile || mobile.length < 5) {
        setLoginError(true);
        setErrorMsg('Please enter a valid mobile number.');
        return; // Stop execution
      }
      let completeMobile = countryCode + mobile;

      completeMobile = completeMobile.replace(/\+/g, '');

      setLoginError(false);
      setErrorMsg('');
      setOnboardingMessage('');
      setLocalStorage(LAST_DIAL_CODE_KEY, countryCode);
      if (route.name === 'Cc-admin-login') {
        sendOtpApi(
          {
            mobile: completeMobile,
            countryCode,
            source: 'learn',
            password: ccadminpassword,
            admin_login: true,
          },
          {
            onSuccess: response => {
              if (response?.success === false) {
                setLoginError(true);
                // A success:false with a blank/absent `error` used to paint an
                // empty banner; fall back to a real sentence.
                setErrorMsg(
                  extractApiErrorMessage(
                    response,
                    'An error occurred during the login process.',
                  ),
                );
                setIsOtpSent(false);
              } else {
                sendOtpSuccess();
              }
            },
            onError: error => {
              console.log('Error occurred while trying to login: ', error);
              setLoginError(true);
              // react-query runs the mutation-level callbacks (handleOnError,
              // which already reads the server's message) BEFORE these
              // mutate-level ones, so a hardcoded string here overwrote the
              // real reason every time.
              setErrorMsg(
                extractApiErrorMessage(
                  error,
                  'An error occurred during the login process.',
                ),
              );
              setIsOtpSent(false);
            },
          },
        );
      } else {
        sendOtpApi(
          {mobile: completeMobile, countryCode, source: 'learn'},
          {
            onSuccess: response => {
              const {onboardingHalted, errorMessage} =
                interpretSendOtpResponse(response);
              if (onboardingHalted) {
                setOnboardingMessage('Onboarding halted');
                setIsOtpSent(false);
              } else if (errorMessage) {
                // A 200 carrying success:false is still a failure -- showing
                // the OTP box for an OTP that was never sent left the user
                // waiting on an SMS that could not arrive.
                setLoginError(true);
                setErrorMsg(errorMessage);
                setIsOtpSent(false);
              } else {
                sendOtpSuccess(response);
                // CSoC assessment lead: OTP was actually sent, so capture the
                // lead now. Fires only for clicks that came from a Caissa
                // School of Chess page (csoc_lead=1 marker). completeMobile is
                // the full E.164 number without "+".
                if (isCsocAssessmentLead()) {
                  submitCsocCallback({
                    fullPhone: completeMobile,
                    countryCode,
                    email: loginData.email,
                  });
                }
              }
            },
            onError: error => {
              console.log('Error occurred while trying to login: ', error);
              setLoginError(true);
              setErrorMsg(
                extractApiErrorMessage(
                  error,
                  'An error occurred during the login process.',
                ),
              );
              setIsOtpSent(false);
            },
          },
        );
      }
    } catch (e) {
      console.log('Error occurred while trying to login .. ', e);
    }
  };

  const verifyOtpRequest = () => {
    try {
      let {mobile, otp} = loginData;
      if (!otp || otp.replace(/\D/g, '').length !== 4) {
        setLoginError(true);
        setErrorMsg('Please enter a valid 4-digit OTP');
        return;
      }
      if (tnc > 0 && !checkboxValue) {
        setLoginError(true);
        setErrorMsg('Please accept terms and conditions to continue');
        return;
      }
      let completeMobile = countryCode + mobile;
      completeMobile = completeMobile.replace(/\+/g, '');

      setLoginError(false);
      setErrorMsg('');
      mobile = completeMobile;
      if (route.name === 'Cc-admin-login') {
        verifyOtpApi({
          mobile,
          countryCode,
          otp,
          admin_login: route.name === 'Cc-admin-login',
        });
      } else {
        verifyOtpApi({
          mobile,
          countryCode,
          otp,
          terms: checkboxValue,
        });
      }
    } catch (e) {
      console.log('Error occurred while trying to login .. ', e);
    }
  };

  const changeNumber = () => {
    setIsOtpSent(false);
    setLoginError(false);
    setErrorMsg('');
    setOnboardingMessage('');
  };

  const loginWithOtp = (
    <>
      <ConditionalRender
        condition={!isOtpSent}
        childrenA={
          <Box
            flexDirection={'column'}
            justifyContent="center"
            alignItems="stretch"
            gap={10}
            style={{width: '100%'}}>
            <Box style={styles.pillRow} flexDirection="row" alignItems="center">
              <CCSelect
                useAsync
                placeholder=""
                options={codesArray}
                value={codesArray.find(o => o.value === countryCode) || null}
                onChange={(option: any) => {
                  if (option?.value) {
                    setCountryCode(option.value);
                  }
                }}
                AsyncStyles={countrySelectStyles}
              />
              <View style={styles.pillDivider} />
              <CCTextInput
                outlineColor={CCColors.White}
                outlineActiveColor={CCColors.White}
                labelActiveColor=""
                inputType="phone"
                label="Enter Mobile Number"
                style={styles.pillInput}
                value={loginData.mobile}
                fontSize={14}
                maxLength={countryCode === '+91' ? 10 : undefined}
                onChangeText={(text: string) => {
                  handleLoginDataChange(text, 'mobile');
                }}
                onSubmitEditing={sendOtpRequest}
                returnKeyType="done"
                onEnterPress={() => {
                  if (loginData.mobile.trim()) {
                    sendOtpRequest();
                  }
                }}
                testID="input-mobile-number"
              />
            </Box>
            {route.name === 'Cc-admin-login' && (
              <Box
                style={styles.adminInputBox}
                flexDirection="row"
                alignItems="center">
                <CCTextInput
                  outlineColor={CCColors.White}
                  outlineActiveColor={CCColors.White}
                  labelActiveColor=""
                  inputType="text"
                  label="Enter password"
                  style={styles.adminInput}
                  value={loginData.ccadminpassword}
                  secureTextEntry={viewpassword ? false : true}
                  fontSize={14}
                  onChangeText={(text: string) => {
                    handleLoginDataChange(text, 'ccadminpassword');
                  }}
                  onSubmitEditing={sendOtpRequest}
                  returnKeyType="done"
                  rightIcon={
                    <TouchableOpacity
                      onPress={() => setViewPassword(!viewpassword)}
                      style={{paddingRight: 14}}>
                      <MaterialCommunityIcons
                        name={viewpassword ? 'eye-outline' : 'eye-off-outline'}
                        size={20}
                        color="grey"
                      />
                    </TouchableOpacity>
                  }
                />
              </Box>
            )}
          </Box>
        }
        childrenB={
          <Box
            flexDirection="column"
            alignItems="center"
            style={{width: '100%'}}>
            <CCText style={styles.otpHeadline}>Enter the code</CCText>
            {!!loginData.mobile && (
              <CCText style={styles.otpSubline}>
                {formatSentTo(countryCode, loginData.mobile)}
              </CCText>
            )}
            <Spacer spacing={20} />
            <OtpInput
              value={loginData.otp}
              onChange={text => handleLoginDataChange(text, 'otp')}
              numInputs={4}
              shouldAutoFocus
              // Numeric keypad on phones. (It doesn't restrict typing on a
              // desktop keyboard — the onKeyDown guard below does that.)
              inputType="tel"
              renderSeparator={<span>&nbsp;&nbsp;</span>}
              inputStyle={{...styles.otpBox}}
              renderInput={props => (
                <input
                  {...props}
                  data-testid="otp-input"
                  onKeyDown={e => {
                    if (e.key === 'Enter' && loginData.otp.length === 4) {
                      e.preventDefault();
                      verifyOtpRequest();
                      return;
                    }
                    // Printable non-digits never belong in an OTP box. Without
                    // this you could type "=" into a cell (and it stuck,
                    // because nothing cleared it).
                    if (
                      e.key.length === 1 &&
                      !/\d/.test(e.key) &&
                      !e.ctrlKey &&
                      !e.metaKey
                    ) {
                      e.preventDefault();
                      return;
                    }
                    // Hand off to react-otp-input. THIS is what was missing:
                    // the library supplies its own onKeyDown in `props` — the
                    // handler that owns Backspace, Delete and arrow-key
                    // navigation — and spreading props before declaring
                    // onKeyDown here silently replaced it. Backspace did
                    // nothing, so a wrong digit could not be corrected.
                    props.onKeyDown?.(e);
                  }}
                />
              )}
            />
          </Box>
        }
      />
      <Spacer spacing={20} />
      <ConditionalRender
        condition={loginError}
        childrenA={<CCText style={styles.errorText}>{errorMsg}</CCText>}
        childrenB={<></>}
      />
      {!isOtpSent && (
        <Box flexDirection="row" style={styles.termsRow} flexWrap="wrap">
          <CCText fontSize={11} color={CCColors.Login.Muted}>
            By continuing you agree to our{' '}
          </CCText>
          <TouchableOpacity onPress={() => setShowPopup(true)}>
            <CCText
              fontSize={11}
              color={CCColors.BlueAqua}
              style={{textDecorationLine: 'underline'}}>
              Terms
            </CCText>
          </TouchableOpacity>
          <CCText fontSize={11} color={CCColors.Login.Muted}>
            {' '}
            &amp;{' '}
          </CCText>
          <TouchableOpacity onPress={() => setShowPopup(true)}>
            <CCText
              fontSize={11}
              color={CCColors.BlueAqua}
              style={{textDecorationLine: 'underline'}}>
              Privacy Policy
            </CCText>
          </TouchableOpacity>
          <CCText fontSize={11} color={CCColors.Login.Muted}>
            .
          </CCText>
        </Box>
      )}
      <Spacer spacing={20} />
      <Box flexDirection="column" alignItems="center" style={{width: '100%'}}>
        <ConditionalRender
          condition={isOtpSent}
          childrenA={
            <>
              {tnc > 0 && (
                <>
                  <Box style={styles.termsRow}>
                    <CCCheckbox
                      label={
                        tnc === 2 ? (
                          <Box>
                            <CCText fontSize={FontSizes[14]}>
                              By continuing you agree to CircleChess'{' '}
                              <span
                                style={{
                                  color: CCColors.BlueAqua,
                                  textDecoration: 'underline',
                                }}>
                                terms and conditions.
                              </span>
                            </CCText>
                          </Box>
                        ) : tnc === 1 ? (
                          <Box>
                            <CCText fontSize={FontSizes[14]}>
                              Please agree to CircleChess'{' '}
                              <span
                                style={{
                                  color: CCColors.BlueAqua,
                                  textDecoration: 'underline',
                                }}>
                                terms and conditions.
                              </span>
                            </CCText>
                          </Box>
                        ) : null
                      }
                      value={checkboxValue}
                      onValueChange={(label, newValue) => {
                        setCheckboxValue(newValue);
                      }}
                      customStyle={{
                        alignItems: 'center',
                      }}
                      onLabelPress={() => setShowPopup(true)}
                      customFont={12}
                    />
                  </Box>
                  <Spacer spacing={20} />
                </>
              )}
              {/* Verify is the primary action and owns the full width; "Change
                  number" is a secondary escape hatch, so it sits under the CTA
                  as plain text rather than competing as a second button.
                  Cross-axis stays `stretch` (Box's default) — buttonWrapperMobile
                  is width:'100%', which collapses to the text width if the
                  column shrink-wraps. The link centres itself instead. */}
              <Box flexDirection="column" gap={14} style={{width: '100%'}}>
                <CCButton
                  style={[
                    styles?.buttonWrapper,
                    isMobileOrTab && styles.buttonWrapperMobile,
                  ]}
                  onPress={verifyOtpRequest}
                  disabled={tnc > 0 ? !checkboxValue : isVerifyOtpLoading}
                  testID="btn-verify-otp">
                  <CCText
                    fontSize={FontSizes[14]}
                    fontWeight="semibold"
                    color={CCColors.Login.Ink}>
                    Verify OTP
                  </CCText>
                </CCButton>
                <Pressable
                  onPress={changeNumber}
                  testID="btn-change-number"
                  style={({hovered}: any) => [
                    styles.changeNumberLink,
                    hovered && styles.changeNumberLinkHovered,
                  ]}>
                  <CCText
                    fontSize={FontSizes[13]}
                    style={styles.changeNumberText}>
                    Change number
                  </CCText>
                </Pressable>
              </Box>
            </>
          }
          childrenB={
            <CCButton
              style={[
                styles?.buttonWrapper,
                isMobileOrTab && styles.buttonWrapperMobile,
              ]}
              onPress={sendOtpRequest}
              disabled={isSendOtpLoading}
              testID="btn-submit-otp">
              <CCText
                fontSize={FontSizes[14]}
                fontWeight="semibold"
                color={CCColors.Login.Ink}>
                Get OTP
              </CCText>
            </CCButton>
          }
        />

        {onboardingMessage && (
          <CCText
            style={{
              fontSize: 16,
              color: CCColors?.Red,
              marginTop: 8,
            }}>
            {onboardingMessage}
          </CCText>
        )}
      </Box>
    </>
  );
  const handleSwitchToAppBannerModal = () => {
    setShowAppModalHome(true);
  };
  return (
    <SafeAreaWrapper>
      <View>
        <Modal visible={showAppModalHome} transparent animationType="fade">
          <SwitchToAppModal
            setShowAppModalHome={setShowAppModalHome}
            isMobileOrTab={isMobileOrTab}
          />
        </Modal>
        {isMobileOrTab && (
          <SwitchToAppBanner
            handleSwitchToAppBannerClose={handleSwitchToAppBannerModal}
          />
        )}
        <Box
          style={styles.container}
          flexDirection={isMobileOrTab ? 'column' : 'row'}>
          {showPopup && (
            <SlideModal
              type="center"
              contentPadding={15}
              visible={showPopup}
              minWidth={200}
              closeIconSize={22}
              dynamicHeight={30}
              dynamicWidth={30}
              onClose={() => setShowPopup(false)}
              customStyle={{width: '45%', height: '60%'}}
              customMobileStyle={[
                styles.modal,
                {
                  borderRadius: !isMobileOrTab && 12,

                  ...(isMobileOrTab && {
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                  }),
                },
              ]}
              customMargin={0}
              modalHeaderTitle={
                <Box
                  flexDirection="row"
                  gap={15}
                  style={{alignItems: 'center'}}>
                  <FontAwesomeIcon icon={faFileContract} style={styles.icon} />
                  <CCText fontSize={FontSizes[18]} fontWeight="semibold">
                    Terms and Conditions for CircleChess Portal
                  </CCText>
                </Box>
              }>
              <TncContext
                terms={tnc}
                onAgree={() => {
                  setCheckboxValue(true);
                  setShowPopup(false);
                }}
              />
            </SlideModal>
          )}
          {/* Persistent illustration/carousel panel — desktop only. On mobile
              there's a single carousel, inline in the form column below. */}
          {!isMobileOrTab && (
            <Box style={styles.sidePanelDesktop}>
              <Image
                source={loginSidePattern}
                style={styles.sidePanelPattern}
              />
              <DecorativePieces items={BROWN_PANEL_DECOR} color={CCColors.White} />
              <Box style={styles.sidePanelInner}>
                <Image
                  source={ccLogoOnDark}
                  style={styles.sidePanelLogo}
                />
                <Box style={styles.sidePanelHeadlineBlock}>
                  <CCText
                    style={[
                      styles.sidePanelHeadline,
                      sidePanelContentWidth < 420 && {
                        fontSize: 30,
                        lineHeight: 34,
                      },
                    ]}
                    fontWeight="thunder"
                    numberOfLines={1}>
                    Play, Enjoy &amp; Learn
                  </CCText>
                  <CCText style={styles.sidePanelSupport}>
                    FIDE-rated coaches, daily puzzles and an AI coach — built
                    for young players, with parents in control.
                  </CCText>
                </Box>
                <FeatureCarousel
                  width={sidePanelContentWidth}
                  dotInactiveColor="rgba(255,255,255,0.3)"
                />
                <Box
                  flexDirection="row"
                  gap={32}
                  style={styles.uspRow}>
                  {SIDE_PANEL_USPS.map(usp => (
                    <Box key={usp.label} style={styles.uspItem}>
                      <View style={styles.uspIconCircle}>
                        <CCText fontSize={22} color={CCColors.Login.Gold}>
                          {usp.glyph}
                        </CCText>
                      </View>
                      <CCText style={styles.uspLabel}>{usp.label}</CCText>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          )}

          {/* Form column — a white card on a cream backdrop on desktop. On
              mobile: a brown hero band (carousel only) up top, matching the
              side panel's color, then the plain cream body below it. */}
          <Box
            flex={1}
            style={isMobileOrTab ? styles.formHalfMobile : styles.formPanelDesktop}>
            {isMobileOrTab && !isOtpSent && (
              <Box style={styles.mobileHeroBrown}>
                <DecorativePieces items={MOBILE_HERO_DECOR} color={CCColors.White} />
                <FeatureCarousel
                  width={mobileContentWidth}
                  dotInactiveColor="rgba(255,255,255,0.3)"
                />
              </Box>
            )}
            {!isMobileOrTab && (
              <>
                <Image
                  source={loginSidePattern}
                  style={styles.formPanelPattern}
                />
                <DecorativePieces
                  items={CREAM_PANEL_DECOR}
                  color={CCColors.Login.Ink}
                />
              </>
            )}
            <Box style={isMobileOrTab ? styles.mobileBody : styles.formCardDesktop}>
            {isMobileOrTab && (
              <DecorativePieces items={MOBILE_PANEL_DECOR} color={CCColors.Login.Ink} />
            )}
            <Box
              style={{
                width: isMobileOrTab ? '100%' : '100%',
                maxWidth: '100%',
                alignSelf: 'center',
              }}>
              {!isMobileOrTab && (
                <Image source={ccLogoOnLight} style={styles.formCardLogo} />
              )}
              {isMobileOrTab && (
                <Image source={ccLogoOnLight} style={styles.mobileLogo} />
              )}
              {!isOtpSent && !isMobileOrTab && (
                <Box
                  flexDirection="column"
                  alignItems="center"
                  style={{width: '100%'}}>
                  <CCText style={styles.heroHeadline}>
                    {LOGIN_HERO.headline}
                  </CCText>
                  <CCText style={[styles.heroSupport, {fontSize: 15}]}>
                    {LOGIN_HERO.support}
                  </CCText>
                </Box>
              )}
              {!isOtpSent && isMobileOrTab && (
                <CCText style={styles.heroSupport}>
                  {LOGIN_HERO.instruction}
                </CCText>
              )}
              <Spacer spacing={20} />
              {loginWithOtp}
              <Spacer spacing={24} />
              {isOtpSent && (
                <Box flexDirection="row" style={{justifyContent: 'center'}}>
                  <ConditionalRender
                    condition={counter.length > 0}
                    childrenA={
                      <CCText style={{color: CCColors.Login.Label}}>
                        Didn't received code? Retry after {counter}
                      </CCText>
                    }
                    childrenB={
                      <CCText
                        style={{color: '#3DAB9E', marginLeft: 4}}
                        onPress={sendOtpRequest}>
                        Resend Now
                      </CCText>
                    }
                  />
                </Box>
              )}
            </Box>
            </Box>
          </Box>
        </Box>
      </View>
    </SafeAreaWrapper>
  );
}

const countrySelectStyles = {
  container: (base: any) => ({
    ...base,
    width: 130,
  }),

  control: (base: any) => ({
    ...base,
    minHeight: 48,
    height: 48,
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
  }),

  valueContainer: (base: any) => ({
    ...base,
    padding: '0 10px',
    justifyContent: 'center',
  }),

  singleValue: (base: any) => ({
    ...base,
    fontSize: 13,
    color: CCColors.Login.Ink,
    margin: 0,
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),

  indicatorsContainer: (base: any) => ({
    ...base,
    padding: 0,
  }),

  dropdownIndicator: (base: any) => ({
    ...base,
    padding: 4,
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
    minWidth: 220,
  }),
};

export default Login;
